/**
 * receiptDialogBus: open the one receipt dialog from anywhere.
 *
 * The dialog (components/Orders/ReceiptPrintDialog.js) is mounted ONCE in
 * App.js, beside the COD cash receipt dialog. Every order page and card prints
 * through utilities/openReceipt.js, which fetches the signed receipt link and
 * publishes it here, so none of them holds dialog state and the operator stays
 * on the page they were working on.
 *
 *   openReceiptDialog({ orderId, viewUrl })
 *   openReceiptDialog({ viewUrl, title: "CREDIT NOTE" })   any signed document page
 */
const listeners = new Set();

export const openReceiptDialog = (request) => {
  listeners.forEach((listener) => listener(request));
};

export const subscribeReceiptDialog = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
